import { useState } from 'react';

import { Button, Card, Typography } from 'antd';

import { useImpactReport } from 'v2/hooks/useImpactReport';
import { useUserStore } from 'v2/store/User';

import { Icon } from '@eduzz/ui-antd-theme';

import DiplomaModal from './DiplomaModal';

const DIPLOMA_BANNER_TITLE = 'Seu diploma de Criador (a) de Impacto está pronto.';
const DIPLOMA_BANNER_SUBTITLE = 'Baixe e compartilhe seu reconhecimento.';
const DIPLOMA_BANNER_CARD_CLASS =
  'mt-4 mb-24 overflow-hidden border-none bg-[linear-gradient(90deg,#0F1324_0%,#1B2340_100%)] sm:bg-[linear-gradient(90deg,#0F1324_0%,#1B2340_55%,#3A2E3A_80%,#C98A4B_100%)]';

function DiplomaBanner() {
  const user = useUserStore(state => state.user);
  const { data: report } = useImpactReport(user?.id);
  const [diplomaOpen, setDiplomaOpen] = useState(false);

  if (!user?.id || !report) {
    return null;
  }

  const userId = report.customerId ?? user.id;
  const defaultName = report.customerName || user.business_name || user.full_name || '';

  return (
    <>
      <Card id='impact-diploma-banner' className={DIPLOMA_BANNER_CARD_CLASS} classNames={{ body: 'px-5 py-4' }}>
        <div className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
          <div className='flex items-start gap-3 sm:items-center'>
            <div className='flex size-10 shrink-0 items-center justify-center rounded-full bg-white/10'>
              <Icon.Award size={20} className='text-(--uizz-antd-color-warning)' aria-hidden />
            </div>
            <div className='flex min-w-0 flex-col gap-0.5'>
              <Typography.Text strong className='text-sm text-balance text-(--uizz-antd-color-white) sm:text-base'>
                {DIPLOMA_BANNER_TITLE}
              </Typography.Text>
              <Typography.Text className='text-xs text-(--uizz-antd-color-white) opacity-70'>
                {DIPLOMA_BANNER_SUBTITLE}
              </Typography.Text>
            </div>
          </div>
          <Button
            id='impact-diploma-banner-trigger'
            color='gold'
            variant='solid'
            aria-haspopup='dialog'
            aria-expanded={diplomaOpen}
            aria-controls='impact-meter-diploma'
            className='w-full shrink-0 sm:w-auto'
            onClick={() => setDiplomaOpen(true)}
          >
            Baixar diploma
          </Button>
        </div>
      </Card>

      <DiplomaModal
        open={diplomaOpen}
        onClose={() => setDiplomaOpen(false)}
        userId={userId}
        defaultName={defaultName}
        report={report}
      />
    </>
  );
}

export default DiplomaBanner;
